import React, { Component } from 'react';
import swal from 'sweetalert2';
import { Form } from 'react-form';
import { reinitialiserMdpE3 } from '../../../App_Code/API';
import { estMotdePasseValide } from '../../../App_Code/Utils';
import { MDP_TAILLE_MIN, MDP_TAILLE_MAX } from '../../../App_Data/Consts';
import * as HttpStatus from '../../../App_Data/HttpStatus';
import { AfficherFeedback, Texte } from '../../ChampFormulaire';

class PageRedefinir extends Component {
    constructor(props) {
        super(props);

        this.nouveauMdpInput = React.createRef();
        this.confirmationMdp = React.createRef();
        this.envoyerInput = React.createRef();

        if (props.location && props.location.search) {
            const params = new URLSearchParams(props.location.search);
            this.email = params.get('email');
            this.cle = params.get('cm');
            this.num = params.get('num');
        }
    }

    componentDidMount() {
        if (!this.email || !this.cle || !this.num) {
            this.props.history.push('/');
        }
    }

    handleSubmit = (submittedValues) => {
        const { nouveauMdp, confirmationMdp } = submittedValues;
        const { history } = this.props;
        this.envoyerInput.current.disabled = true;

        const nouveauMdpValide = estMotdePasseValide(nouveauMdp);
        AfficherFeedback(this.nouveauMdpInput, nouveauMdpValide);

        const confirmationMdpValide = nouveauMdp === confirmationMdp;
        AfficherFeedback(this.confirmationMdp, confirmationMdpValide);

        if (!nouveauMdpValide || !confirmationMdpValide) {
            this.envoyerInput.current.disabled = false;
            return;
        }

        reinitialiserMdpE3(this.email, this.cle, this.num, nouveauMdp).then((response) => {
            if (response.status === HttpStatus.OK) {
                history.push({
                    pathname: '/MotdepasseOublie/Valide',
                    search: `email=${this.email}&ok`,
                });
            } else {
                swal({
                    type: 'error',
                    title: 'Erreur',
                    text: 'Impossible de valider le changement de mot de passe.',
                    footer: response.data.Message.replace(/["]+/g, ''),
                });
                this.envoyerInput.current.disabled = false;
            }
        });
    };

    render() {
        return (
            <Form onSubmit={this.handleSubmit}>
                {formApi => (
                    <form onSubmit={formApi.submitForm}>
                        <h5 className="card-title">Redéfinir le mot de passe</h5>
                        <div className="form-group required">
                            <label htmlFor="RedefinirNouveauMdp">Nouveau mot de passe</label>
                            <Texte
                                id="RedefinirNouveauMdp"
                                field="nouveauMdp"
                                placeholder="Nouveau mot de passe"
                                type="password"
                                refRef={this.nouveauMdpInput}
                            />
                            <div className="invalid-feedback">
                                La taille doit être comprise entre {MDP_TAILLE_MIN} et {MDP_TAILLE_MAX} caractères
                            </div>
                        </div>
                        <div className="form-group required">
                            <label htmlFor="RedefinirConfirmationMdp">Confirmation mot de passe</label>
                            <Texte
                                id="RedefinirConfirmationMdp"
                                field="confirmationMdp"
                                placeholder="Confirmation mot de passe"
                                type="password"
                                refRef={this.confirmationMdp}
                            />
                            <div className="invalid-feedback">Le mot de passe ne correspond pas</div>
                        </div>
                        <button type="submit" className="btn btn-block btn-lg btn-success" ref={this.envoyerInput}>
                            Valider le changement
                        </button>
                    </form>
                )}
            </Form>
        );
    }
}
export default PageRedefinir;



// WEBPACK FOOTER //
// ./src/components/Adherent/MdpOublie/PageRedefinir.js